import { setTerm } from './helpers';

export const setRentalPeriod = setTerm('for_day');
